import React from 'react';

import styles from './quote.module.css';

const Quote = ({text, title, name}) => {
  return (
    <div className={styles.quoteCard}>
      <div className={styles.text}>
        <span className={styles.quote}>"</span>
          { text }
        <span className={styles.quote}>"</span>
      </div>
      <div className={styles.koo}>
        <div className={styles.title}> { title }</div>
        <div className={styles.name}> { name }</div>
      </div>
    </div>
  )
}

export default Quote;